
export const getValidToken = (email?: string) => {
  // If no email provided, return null
  if (!email) {
    console.log("No email provided for token lookup");
    return null;
  }

  const tokenKey = `gmail_access_token_${email}`;
  const expiryKey = `gmail_token_expiry_${email}`;
  
  const accessToken = localStorage.getItem(tokenKey);
  const tokenExpiry = localStorage.getItem(expiryKey);
  
  if (!accessToken) {
    console.log(`No access token found for ${email}`);
    return null;
  }
  
  if (!tokenExpiry) {
    console.log(`No token expiry found for ${email}`);
    return null;
  }
  
  const expiryTime = parseInt(tokenExpiry);
  const currentTime = Date.now();
  
  if (currentTime > expiryTime) {
    console.log(`Token expired for ${email}. Current time: ${new Date(currentTime).toISOString()}, Expiry time: ${new Date(expiryTime).toISOString()}`);
    localStorage.removeItem(tokenKey);
    localStorage.removeItem(expiryKey);
    return null;
  }
  
  console.log(`Found valid token for ${email}. Expires in ${Math.round((expiryTime - currentTime) / 1000 / 60)} minutes`);
  return accessToken;
};

export const setGmailToken = (email: string, token: string, expiryTime: number) => {
  const tokenKey = `gmail_access_token_${email}`;
  const expiryKey = `gmail_token_expiry_${email}`;
  
  localStorage.setItem(tokenKey, token);
  localStorage.setItem(expiryKey, expiryTime.toString());
  console.log(`Stored new token for ${email}. Expires at: ${new Date(expiryTime).toISOString()}`);
};

export const clearGmailTokens = (email: string) => {
  const tokenKey = `gmail_access_token_${email}`;
  const expiryKey = `gmail_token_expiry_${email}`;
  
  localStorage.removeItem(tokenKey);
  localStorage.removeItem(expiryKey);
  console.log(`Cleared tokens for ${email}`);
};
